import { useEffect, useState } from 'react'

// `false` during server and hydration render, `true` after commit. Gate
// client-only branches on this to avoid hydration mismatches.
export const useHasMounted = (): boolean => {
  const [hasMounted, setHasMounted] = useState(false)
  useEffect(() => {
    setHasMounted(true)
  }, [])
  return hasMounted
}
